import { AlertBanner } from '@apollo/orbit';
import React from 'react';

export function ProposalsAlertBanner() {
  return (
    <AlertBanner
      status="info"
      key="info"
      isDismissible={false}
      isOpen={true}
      className="mt-2"
    >
      If new fields with usage have been added to the source variant since this
      Proposal was created, operations check on this Proposal will be broken
      with new fields listed as "field removed". Please Pull Changes to fix.
    </AlertBanner>
  );
}
